import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '../Typography'
import {
  CardContainer,
  CardContainerInside,
  Container,
  IconNotice,
  StyledNoticeAboutSwitchCards,
} from './CardHolder.styles'
import { CardHolderViewModel } from './CardHolder.types'
import CombinationLabel from './views/CombinationLabel'
import CompactCardsView from './views/CompactCardsView'
import DetailCardsView from './views/DetailCardsView'

type Props = {
  viewModel: CardHolderViewModel
}

const CardHolderView: FC<Props> = ({ viewModel }) => {
  const { t } = useTranslation()

  const {
    viewMode,
    cards,
    combination,
    animateCombination,
    showSwitchNotice,
    enableHoverFlip,
    extraAction,
    cardInteraction,
    cardSlots,
    isDetailView,
    hasTopOffset,
    onRevealComplete,
    showCombination,
  } = viewModel

  return (
    <Container>
      {showSwitchNotice && (
        <StyledNoticeAboutSwitchCards>
          <IconNotice
            color="gold1"
            size={{
              mobile: '6px',
              tablet: '12px',
              desktop: '15px',
            }}
          />
          <Typography variant="gameInfo" color="gold1">
            {t('selectCardsForSwitch')}
          </Typography>
        </StyledNoticeAboutSwitchCards>
      )}

      <CombinationLabel
        combination={combination}
        animate={animateCombination}
        visible={showCombination}
      />

      <CardContainer isDetailView={isDetailView} hasTopOffset={hasTopOffset}>
        <CardContainerInside count={cardSlots} isDetailView={isDetailView}>
          {viewMode === 'compact' && (
            <CompactCardsView cards={cards} cardSlots={cardSlots} />
          )}

          {viewMode === 'detail' && (
            <DetailCardsView
              cards={cards}
              enableHoverFlip={enableHoverFlip}
              cardInteraction={cardInteraction}
              extraAction={extraAction}
              onRevealComplete={onRevealComplete}
            />
          )}
        </CardContainerInside>
      </CardContainer>
    </Container>
  )
}

export default CardHolderView
